<template>
  <div>
    <h2 class="text-md-h6 text-subtitle-1 font-weight-bold mt-md-8 my-3">
      <translate>About</translate> {{course.name}}
    </h2>

    <v-card class="pa-md-6 pa-4 holeAbout">
      <v-row no-gutters justify="space-between">
        <div class="d-flex">
          <h5
            v-if="course && course.holeTotal"
            class="page-subtitle my-6 d-flex justify-space-between align-center"
          >
            <translate>Number of Holes: </translate>
          </h5>
          <v-text-field
            outlined
            height="24"
            hide-details
            v-model="holeTotal"
            class="ml-4 mr-md-8 mt-4"
            style="max-width: 90px;"
          ></v-text-field>
        </div>
        <div class="actionSection ml-md-4 d-flex align-center">
          <ButtonEdit
            v-if="isCourseAdmin"
            :text="$gettext('Edit')"
            @click="$emit('editHoleTable')"
          />
        </div>
      </v-row>
      <ul class="holes d-flex pl-0">
        <li
          class="subtitle-2 pb-0"
          style="height: 50px"
          v-for="(hole, index) in holesList"
          :key="index"
        >
          <span class="mt-3">{{ hole.name }}</span>

          <v-radio-group class="mt-0" v-model="hole.status" row>
            <v-radio label="Yes" :value="true"></v-radio>
            <v-radio label="No" :value="false"></v-radio>
          </v-radio-group>
        </li>
      </ul>
      <div class="mt-5">
        <v-btn
          small
          @click="$emit('editHoleTable')"
          class="font-weight-bold elevation-0 text-none subtitle-1 mr-3 px-4 py-5"
        >
          <translate>Cancel</translate>
        </v-btn>
        <v-btn
          small
          type="submit"
          color="primary"
          @click="onSubmit"
          class="font-weight-bold elevation-0 text-none subtitle-1 px-4 py-5"
        >
          <translate>Save</translate>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
export default {
  name: "HoleAboutCourseEdit",
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  components: {
    ButtonEdit,
  },
  data() {
    return {
      holeTotal: 0,
    };
  },
  computed: {
    course() {
      this.holeTotal = this.$store.state.golfcourse.courseDetail.holeTotal;
      return this.$store.state.golfcourse.courseDetail;
    },
    holesList() {
      return [
        {
          name: this.$gettext("Driving Range"),
          status: this.course ? this.course.drivingRange : false,
          textField: "drivingRange",
        },
        {
          name: this.$gettext("Pro Shop"),
          status: this.course ? this.course.proShop : false,
          textField: "proShop",
        },
        {
          name: this.$gettext("Putting Green"),
          status: this.course ? this.course.puttingGreen : false,
          textField: "puttingGreen",
        },
        {
          name: this.$gettext("Golf Lessons"),
          status: this.course ? this.course.golfLesson : false,
          textField: "golfLesson",
        },
        {
          name: this.$gettext("Chipping Green"),
          status: this.course ? this.course.chippingGreen : false,
          textField: "chippingGreen",
        },
        {
          name: this.$gettext("Caddie Hire"),
          status: this.course ? this.course.caddieHire : false,
          textField: "caddieHire",
        },
        {
          name: this.$gettext("Practice Bunker"),
          status: this.course ? this.course.practiceBunker : false,
          textField: "practiceBunker",
        },
        {
          name: this.$gettext("Restaurant"),
          status: this.course ? this.course.restaurant : false,
          textField: "restaurant",
        },
        {
          name: this.$gettext("Motor Cart"),
          status: this.course ? this.course.motorCart : false,
          textField: "motorCart",
        },
        {
          name: this.$gettext("Reception Hall"),
          status: this.course ? this.course.receptionHall : false,
          textField: "receptionHall",
        },
        {
          name: this.$gettext("Pull Cart"),
          status: this.course ? this.course.pullCart : false,
          textField: "pullCart",
        },
        {
          name: this.$gettext("Changing Room"),
          status: this.course ? this.course.changingRoom : false,
          textField: "changingRoom",
        },
        {
          name: this.$gettext("Golf Clubs Rental"),
          status: this.course ? this.course.golfClubRental : false,
          textField: "golfClubRental",
        },
        {
          name: this.$gettext("Lockers"),
          status: this.course ? this.course.lockers : false,
          textField: "lockers",
        },
        {
          name: this.$gettext("Club Fitting"),
          status: this.course ? this.course.clubFitting : false,
          textField: "clubFitting",
        },
        {
          name: this.$gettext("Lodging on Site"),
          status: this.course ? this.course.lodgingOnSite : false,
          textField: "lodgingOnSite",
        },
      ];
    },
  },
  methods: {
    async onSubmit() {
      const data = {};
      this.holesList.map((item) => {
        if (item.textField) {
          const name = item.textField;
          data[name] = item.status;
        }
      });
      (data.id = this.course.id), (data.name = this.course.name);
      data.holeTotal = this.holeTotal;
      const result = await this.$store.dispatch("updateCourse", data);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.$toast.success(this.$gettext(`Update success`));
        await this.$store.dispatch(
          "getDetailCourse",
          this.$route.params.namegolf
        );
        this.$emit("editHoleTable");
      }
    },
  },
};
</script>
<style lang="scss">
.holeAbout {
  .v-input__slot {
    min-height: 42px !important;
  }
}
</style>
